import { PeekBox, PeekCheckbox, PeekCollapse, PeekDivider, PeekStack, PeekTableCell, PeekTableRow, useTheme, } from "@piiqtechnologies/ui-components";
import getProperty from "lodash/get";
import React, { useCallback, useMemo, useState } from "react";
import TableActionsContainer from "./TableActionsContainer";
const ActionsContainer = ({ display, actions, id }) => {
    return (React.createElement(TableActionsContainer, { display: display ? "flex" : "none" }, actions.map((action, i) => {
        return (React.createElement(React.Fragment, { key: `${id}-action-${i}` },
            i !== 0 && React.createElement(PeekDivider, { orientation: "vertical", flexItem: true }),
            action));
    })));
};
export function TableRow({ row, columns, actions, actionsCover, onClick, isSelected, onSelect, showSelectionColumn, selectedContent: SelectedRowContent, expandededContent: ExpandedRowContent, expandButton, }) {
    const theme = useTheme();
    const [isOpen, setIsOpen] = useState(false);
    const [actionsVisible, setActionsVisible] = useState(false);
    const actionsCoverComponents = useMemo(() => {
        if (!actionsCover)
            return [];
        return actionsCover(row);
    }, [actionsCover]);
    const actionsComponents = useMemo(() => {
        if (!actions)
            return [];
        return actions(row);
    }, [actions]);
    const handleMouseEnter = useCallback(() => {
        setActionsVisible(true);
    }, []);
    const handleMouseLeave = useCallback(() => {
        setActionsVisible(false);
    }, []);
    const handleClickRow = useCallback(() => {
        onClick === null || onClick === void 0 ? void 0 : onClick(row);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekTableRow, { key: row._id, id: row._id, onClick: !!onClick ? handleClickRow : undefined, role: "checkbox", "aria-checked": isSelected, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, sx: Object.assign({ bgcolor: theme.palette.grey[50] }, (!onSelect && {
                "&:hover": { bgcolor: theme.palette.grey[100], cursor: onClick && "pointer" },
            })) },
            showSelectionColumn && (React.createElement(PeekTableCell, { padding: "checkbox" }, onSelect ? (React.createElement(PeekCheckbox, { color: "secondary", checked: isSelected, onChange: (e) => onSelect(e.target.checked), sx: { padding: "4px" } })) : (React.createElement(React.Fragment, null)))),
            columns.map((column) => {
                var _a;
                return (React.createElement(PeekTableCell, Object.assign({ onClick: handleClickRow, key: `${row._id}${column.id}` }, column.rowCellProps),
                    React.createElement(PeekBox, { onClick: (event) => event.stopPropagation() }, (_a = (column.render ? column.render(row) : getProperty(row, column.accessor))) !== null && _a !== void 0 ? _a : "-")));
            }),
            !!ExpandedRowContent && !!expandButton && (React.createElement(PeekTableCell, { key: "expand-button" },
                React.createElement(PeekBox, { onClick: (event) => {
                        event.stopPropagation();
                        setIsOpen(!isOpen);
                    } }, expandButton(isOpen)))),
            actions || actionsCover ? (React.createElement(PeekTableCell, { align: "right", width: theme.spacing(15), height: theme.spacing(3) },
                actions && React.createElement(ActionsContainer, { display: actionsVisible, actions: actionsComponents, id: row._id }),
                actionsCover && (React.createElement(ActionsContainer, { display: !actionsVisible, actions: actionsCoverComponents, id: row._id })))) : ("")),
        !!ExpandedRowContent && (React.createElement(PeekTableRow, { sx: { transform: "translateY(-6px)", display: isOpen ? "table-row" : "none" } },
            React.createElement(PeekTableCell, { colSpan: 12 },
                React.createElement(PeekCollapse, { in: isOpen, timeout: "auto", unmountOnExit: true },
                    React.createElement(ExpandedRowContent, Object.assign({}, row)))))),
        isSelected && !!SelectedRowContent && (React.createElement(PeekTableRow, { sx: { transform: "translateY(-16px)" } },
            React.createElement(PeekTableCell, { colSpan: 12 },
                React.createElement(PeekStack, { width: "100%" },
                    React.createElement(PeekDivider, { light: true, orientation: "horizontal", sx: { width: "calc(100% - 14px)" } }),
                    React.createElement(SelectedRowContent, Object.assign({}, row))))))));
}
